module.exports = __webpack_public_path__ + "static/media/hamburger.b532fa28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Dashboard/components/HamburgerButton/assets/hamburger.svg
// module id = 1343
// module chunks = 0